import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { EmailVerificationNotificationEffect } from './email-verification-notification.effect';

@NgModule({
  imports: [
    EffectsModule.forFeature([ EmailVerificationNotificationEffect ])
  ]
})
export class EmailVerificationNotificationModule { }
